const style = {
  select: {
    padding: `5px 15px`,
    width: `100%`,
    overflow: `hidden`,
    background: `#fff`,
    border: `1px solid #ddd`,
    borderRadius: 0,
    '-webkit-appearance': `none`,
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/User/Main/partials/Selector/style/selector.js